import React from 'react';

import { useBreakpointValue } from 'native-base';
import { StyleSheet } from 'react-native';
import { withTypography } from 'ucl/components/text/Typography';

import { Box, BoxProps } from 'components/ui';
import { getDesignToken, primitive, spacing } from 'styles/constants';

import theme from './theme';

export const Container = ({ style, ...props }: BoxProps) => {
  const width = useBreakpointValue({
    base: '100%',
    sm: '75%',
    md: '60%',
    lg: '50%',
  });

  return <Box {...props} style={[styles.container, { width }, style]} />;
};

export const ItemContainer = Box;

export const DebugContainer = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.debugContainer, style]} />
);

export const Item = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.item, style]} />
);

export const TileImageWrapper = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.tileImageWrapper, style]} />
);

export const ItemName = withTypography({
  fontFamily: 'heading',
  fontSize: 'md',
  lineHeight: 22,
  style: { fontWeight: theme.itemNameFontWeight },
});

export const FooterContainer = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.footerContainer, style]} />
);

export const PointLabel = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.pointLabel, style]} />
);

export const ErrorMessage = withTypography({
  textAlign: 'center',
  fontSize: 'md',
  my: '$4',
  lineHeight: 22,
});

const styles = StyleSheet.create({
  container: {
    alignSelf: 'center',
  },
  debugContainer: {
    width: '100%',
    marginVertical: spacing.$2_5,
    gap: spacing.$1,
  },
  item: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: spacing.$4,
    paddingBottom: spacing.$4,
    paddingHorizontal: spacing.$4,
    paddingVertical: spacing.$4,
    paddingTop: spacing.$2,
    backgroundColor: getDesignToken('background-focus'),
    borderRadius: 10,
  },
  tileImageWrapper: {
    height: spacing.$20,
    width: spacing.$20,
    borderRadius: 10,
    marginRight: spacing.$5,
  },
  footerContainer: {
    padding: spacing.$4,
    flex: 1,
    alignItems: 'center',
    flexDirection: 'column',
    borderTopWidth: 1,
    borderTopColor: primitive.$blackOpacity10,
  },
  pointLabel: {
    height: spacing.$6,
    width: spacing.$24,
    alignItems: 'center',
    justifyContent: 'flex-start',
    borderRadius: 8,
    flexDirection: 'row',
  },
});
